export const FormatarDinherio = (valor) => {

    if(!valor || valor == ''){
        return 'R$ 0:00'
    }

    let valor_formatado = valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    return valor_formatado

}